import { render, staticRenderFns } from "./AcceptRejectView.vue?vue&type=template&id=73faef9c&"
import script from "./AcceptRejectView.vue?vue&type=script&lang=js&"
export * from "./AcceptRejectView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports